<template>
  <span>
    <!-- <a class="interactive" @click="isLoggedIn ? openBriefForm() : showAction()">
      <svg-icon id="addBrief"></svg-icon>
      Brief Us
    </a> -->
     <a class="interactive" @click="openBriefForm()">
      <svg-icon id="addBrief"></svg-icon>
      Brief Us
    </a>
    <div class="inner" v-if="showLoginDropDown">
      <ul class="listing shortlists shortlists--custom">
        <li class="shortlist-action" @click="showLogin">
          <svg-icon id="signIn"></svg-icon>
          <span>Log In </span>
        </li>
        <li class="shortlist-action" @click="showSignup">
          <svg-icon id="signUp"></svg-icon>
          <span>Sign Up For Free</span>
        </li>
      </ul>
    </div>
  </span>
</template>

<script>
export default {
  data() {
    return {
      showLoginDropDown: false,
      triggeredAuth: false,
    };
  },
  mounted() {
    window.addEventListener("click", this.delegatedHideBriefUs);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.delegatedHideBriefUs);
  },
  methods: {
    openBriefForm() {
    //   this.$store.dispatch("modals/showAddBrief");
    if (!window.location.href.includes("#brief-us")) {
        // window.open(
        //   "https://forms.monday.com/forms/43eca659e05784ac39181d2ead2572eb?r=use1",
        //   "_blank"
        // );

        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href + "#brief-us"
        );
      }
      this.$store.dispatch("modals/showAddBriefMonday");
    },
    showLogin() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "login");
    },
    showSignup() {
      this.triggeredAuth = true;
      this.$store.commit("user/changeAuthMode", "signup");
    },
    showAction() {
      this.showLoginDropDown = !this.showLoginDropDown;
    },
    delegatedHideBriefUs(e) {
      let target = e.target;

      while (target.parentNode) {
        if (target === this.$el) {
          return;
        }

        target = target.parentNode;
      }

      this.showLoginDropDown = false;
    },
  },
  computed: {
    authenticating() {},
    shouldShow() {
      return (
        !this.$store.getters["user/account"] ||
        this.$store.getters["user/isHirer"]
      );
    },
    isLoggedIn() {
      var loggedInObj = this.$store.getters["user/account"];
      this.showLoginDropDown =
        typeof loggedInObj === "object" ? false : this.showLoginDropDown;
      return loggedInObj;
    },
  },
  watch: {
    authenticating(now) {
      if (!now && this.triggeredAuth && !this.isLoggedIn) {
        this.triggeredAuth = false;
      }
    },
    isLoggedIn(now) {
      if (now && this.triggeredAuth) {
        this.$store.commit("account/hide");
        this.triggeredAuth = false;
        this.showLoginDropDown = false;
      }
    },
  },
};
</script>
